import React, { useEffect } from 'react';
import HeroSection from '../../components/2Home/HeroSection';
import FeaturedSpeakers from '../../components/2Speakers/FeaturedSpeakers';
import HowItWorks from '../../components/2Home/HowItWorks';
import TopSpeakers from '../../components/2Speakers/TopSpeakers';
import PopularTopics from '../../components/2Home/PopularTopics';
import UpcomingEvents from '../../components/2Home/UpcomingEvents';
import CTA from '../../components/2Home/CTA';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "react-i18next";



const Home = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <div dir={languageDirection}>
      <HeroSection />
      <FeaturedSpeakers />
      <HowItWorks />
      <TopSpeakers />
      <PopularTopics />
      <UpcomingEvents />
      <CTA />
    </div>
  );
};

export default Home;
